export default "__VITE_ASSET__ukP1fiwC__"